<template>
<div class="cp_tabs">
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="card_type" v-model="card_type" v-validate="'required'">
                <label class="labeltext">Card Type</label>
                <span v-show="submitted && errors.has('card_type')" class="text-danger">Card Type is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="nameCard" v-model="nameOnCard" v-validate="'required'">
                <label class="labeltext">Name On Card</label>
                <span v-show="submitted && errors.has('nameCard')" class="text-danger">Name On Card is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="card_no" v-model="card_no" v-validate="'required'">
                <label class="labeltext">Card Number</label>
                <span v-show="submitted && errors.has('card_no')" class="text-danger">Card Number is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="CVV" v-model="CVV" v-validate="'required'">
                <label class="labeltext">CVV Number</label>
                <span v-show="submitted && errors.has('CVV')" class="text-danger">CVV Number is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="expDate" v-model="expDate" v-validate="'required'">
                <label class="labeltext">Expiry Date (DD/MM/YYYY)</label>
                <span v-show="submitted && errors.has('expDate')" class="text-danger">Expiry Date is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="PostalCode" v-model="PostalCode" v-validate="'required'">
                <label class="labeltext">Postal Code</label>
                <span v-show="submitted && errors.has('PostalCode')" class="text-danger">Postal Code is required</span>
            </div>
        </div>
        <div class="col-12 text-center">
            <input type="submit" class="cap_btn blue" value="Add Now" @click.stop.prevent="creditCardFunc()">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'card',
    data() {
        return {
            pageLoader : false,
            submitted: false,
            
            card_type: '',
			nameOnCard: '',
			card_no: '',
			CVV: '',
			expDate: '',
			PostalCode: '',
        }
    },
    methods: {
        creditCardFunc(){
			const _that = this
			_that.submitted = true;
			_that.$validator.validate().then(valid => {
				if (valid) {
					console.log('abc1')
					let input_json={
						'globalParams' :{

						},
						'localParams' :{ "parameter" : _that }
					}
					_that.apiFunc(input_json)
				}
			});
		},
    },
}
</script>



// WEBPACK FOOTER //
// src/components/website/payment/methods/card.vue